export const DEFAULT_BOARD_PAGE_SIZE = 10;
export const MAX_BOARD_PAGE_SIZE = 100;
export const BACKGROUND_REFRESH_INTERVAL_TIME = 2 * 60 * 1000; // 2 minutes